export default __webpack_public_path__ + "static/media/000_Korn_Finleys_Reise_nach_Andaria_Sample.4eee289e.mp3";